import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, PenTool } from 'lucide-react';
import { FromLinkForm } from './FromLinkForm';
import { ManualPublishForm } from './ManualPublishForm';

function ManualPublishSubTab() {
  const { t } = useTranslation();
  const [mode, setMode] = useState<'from-link' | 'manual'>('from-link');

  return (
    <div className="space-y-4">
      {/* Mode selector */}
      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => setMode('from-link')}
          className={`p-4 rounded-lg border-2 text-left transition-colors ${
            mode === 'from-link'
              ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20'
              : 'border-[var(--color-border)] bg-[var(--color-bg-secondary)]'
          }`}
        >
          <Link size={24} className="text-purple-500 mb-2" />
          <div className="font-medium text-[var(--color-text)]">{t('pub.manual.fromLink')}</div>
          <div className="text-xs text-[var(--color-text-secondary)] mt-1">
            {t('pub.manual.pasteUrl')}, la AI extrae todo
          </div>
        </button>
        <button
          onClick={() => setMode('manual')}
          className={`p-4 rounded-lg border-2 text-left transition-colors ${
            mode === 'manual'
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
              : 'border-[var(--color-border)] bg-[var(--color-bg-secondary)]'
          }`}
        >
          <PenTool size={24} className="text-blue-500 mb-2" />
          <div className="font-medium text-[var(--color-text)]">{t('pub.manual.manualForm')}</div>
          <div className="text-xs text-[var(--color-text-secondary)] mt-1">
            Completa todos los campos a mano
          </div>
        </button>
      </div>

      {mode === 'from-link' ? <FromLinkForm /> : <ManualPublishForm />}
    </div>
  );
}

export { ManualPublishSubTab };
